import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CommandContentEffects } from './command-content.effects';
import { commandContentFeatureKey, commandContentReducer } from './command-content.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(commandContentFeatureKey, commandContentReducer),
    EffectsModule.forFeature([CommandContentEffects]),
  ],
  providers: [],
})
export class CommandContentStoreModule {}
